<template>
  <div class="main-container">
    <!-- Author: Siddhartha 
      Date: 17/01/2020
    Issue Description: payroll payroll Dashboard children components-->
    <breadcrumb :list="breadcrumbList" />

    <div class="margintop-32" />
    <tl-header type="h1">Payroll</tl-header>
    <div class="twoColumnGridDashboard marginbottom-5p">
      <div class="componentName" v-for="(nav, index) in navList" :key="index">
        <div class="c-title">{{nav.name}}</div>
        <!-- <div class="c-icon"><img src="@/assets/star_normal.svg" /></div> -->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Payroll Dashboard",
          url: ``
        }
      ],
      navList: [
        {
          name: "Download Payroll Report",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Lock FBP Reimbursement",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Payroll Wizard",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Process monthly FBP",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Switch Financial year",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        
      ]
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins

</style>
